/*
 *
 * SplitSchemeConfiguration reducer
 *
 */
import produce from 'immer';
import { DEFAULT_PG_MENU_TAB_STATE } from 'utils/constants';
import {
  DEFAULT_ACTION,
  DISABLE_LOADER,
  ENABLE_LOADER,
  SAVE_CONFIGURATIONS,
  SAVE_ALL_TERMINAL_ID,
  SPLIT_SCHEME,
  UPDATE_FILTERS,
  UPDATE_TABLE_DATA,
  SAVE_STATIC_SPLIT_STATUS,
} from './constants';

const {
  filters: { appliedFilters, dateFilters, ...f },
  ...rest
} = DEFAULT_PG_MENU_TAB_STATE;

export const initialState = {
  isLoading: false,
  activeNavigation: SPLIT_SCHEME,
  filters: { ...f },
  ...rest,
  terminalIdList: [],
  productList: [],
  staticSplitEnabled: false,
};

/* eslint-disable default-case, no-param-reassign */
const splitSchemeConfigurationReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SAVE_CONFIGURATIONS: {
        draft.data = action.data;
        draft.isLoading = false;

        let productList = [];
        draft.data.forEach(item => {
          if (
            !productList.includes(item.productType) &&
            item.productType !== 'SBC'
          )
            productList = [...productList, item.productType];
        });
        draft.productList = productList;
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          hasPrevEnabled,
          hasNextEnabled,
          currentPageRowData,
        } = action.data;
        draft.totalCount = totalCount;
        draft.hasPrev = hasPrevEnabled;
        draft.hasNext = hasNextEnabled;
        draft.currentPageRowData = currentPageRowData;
        break;
      }
      case SAVE_STATIC_SPLIT_STATUS: {
        const { data } = action;
        draft.staticSplitEnabled = data.staticSplitEnabled;
        break;
      }
      case UPDATE_FILTERS: {
        draft.filters = action.data;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case SAVE_ALL_TERMINAL_ID: {
        const { data } = action.data;
        const array = [];
        data.map((subscription, index) =>
          array.push({
            key: index + 1,
            text: subscription.subReferenceId,
            value: subscription.subReferenceId,
          }),
        );
        draft.terminalIdList = array;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default splitSchemeConfigurationReducer;
